import { editStoreBuilder } from '@/main/store/pages/edit/builder';

import { NAME as name, CRUMB_LABEL_KEY } from '../constants';
import { apiProvider } from '../api';

export const store = editStoreBuilder({
	name,
	apiProvider,
	crumbLabel: CRUMB_LABEL_KEY,
	dropdownList: {},
	depTableSettings: {},
	edit: {
		ZaznamId: null as number | null,
		DateStamp: null as string | null,
		CdbMethod: null as string | null,
		DocType: null as string | null,
		XmlDoc: null as string | null,
	},
	depTableNames: [],
	localState: {},
	extraActions: {},
	extraGetters: {},
	extraMutations: {},
	props: {
		mode: null,
	},
});
